import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from 'features/core/shared/widget/widget-data';
import {WidgetDataParam} from 'features/core/shared/widget/widget-data-param';
import {WidgetFactory} from 'features/core/shared/widget/service/widget.factory';
import {MvsFormControlOverwrite} from 'features/core/shared/logic/form/logic/mvs-form-control-overwrite';

/**
 * navItem "Basisdaten" of the ProvisionAgent OBC (04-frontend.md §7), widget alias
 * `cp.agent.base.form`.
 *
 * FORM MECHANISM (H4, skill fe_core_form): METADATA-DRIVEN, no manual Angular form.
 * `WidgetFactory.createWidgetObject(...)` creates an object widget whose runtime implementation
 * `mvs-widget-object` internally renders EXACTLY ONE `<mvs-crud-object>`
 * (`features/core/shared/widget/component/runtime/implementations/mvs-widget-object/
 * mvs-widget-object.component.html:3`). The form template comes from the backend FormObject of
 * alias `cp.ProvisionAgent`; here it is merely restricted via {@link MvsFormControlOverwrite} to
 * the four fields that are relevant from a business perspective.
 *
 * Repo original: `bm-billing-area-details.component.ts` (same construction: @Input id ->
 * refreshComponent() -> one widget -> template with a guard).
 */
@Component({
    selector: 'cp-provision-agent-base-data',
    templateUrl: './cp-provision-agent-base-data.component.html',
    styleUrls: ['./cp-provision-agent-base-data.component.scss'],
    standalone: false
})
export class CpProvisionAgentBaseDataComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;
    initialized: boolean;

    @Input() provisionAgentId: number;

    baseFormWidget: WidgetData;

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent(): void {
        this.refreshComponent();
    }

    /**
     * Rebuilds the master data form.
     *
     * Exactly the four fields from 04 §7 stay visible: agent (`agentDtoId`), status
     * (`entityStatus`), reserve share (`reservePercentage`), and reserve maximum amount
     * (`reserveMaxAmount`). All remaining fields of the template are hidden
     * (`createHideAll` = whitelist).
     */
    refreshComponent(): void {

        if (!this.provisionAgentId) {
            this.baseFormWidget = null;
            this.initialized = true;
            return;
        }

        const formControlOverwrite = MvsFormControlOverwrite.createHideAll(
            'agentDtoId',
            'entityStatus',
            'reservePercentage',
            'reserveMaxAmount'
        );

        /**
         * AI: Object widget (mvs-crud-object) with the master form of the agent.
         *     Source: backend FormObject of alias cp.ProvisionAgent, mode update.
         *     Caseworkers maintain the reserve share and reserve maximum amount here.
         */
        this.baseFormWidget = WidgetFactory.createWidgetObject(
            'cp.agent.base.form',
            'Stammdaten',
            'cp.ProvisionAgent',
            this.provisionAgentId,
            WidgetDataParam.create('formControlOverwrite', formControlOverwrite),
            WidgetDataParam.create('size', 'S')
        );

        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['provisionAgentId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }

}
